import { GalleryMedia, MediaSize } from '@travel/ui/components/Gallery';

import { SearchFormQuery } from './providerList';

import { PLACE_NAVIGATION } from '../constants/provider';

export type Access = {
  value: number;
  unit: string;
  location: string;
};

export type ProviderInformation = {
  id: string;
  isActive: boolean;
  isTest: boolean;
  isBookmarked?: boolean;
  name: string;
  remarks: Array<string>;
  isRemarksGoogleTranslated?: boolean;
  pathId: string;
  catchCopy?: string;
  description: string;
  isDescriptionGoogleTranslated?: boolean;
  starRating: number;
  media: Array<GalleryMedia>;
  location: Location;
  reviewScore: number;
  totalReviews: number;
  certifications: Array<Certification>;
  isJapanStandard: boolean;
  languages?: Array<string>;
  totalRooms?: number;
  facilities: Array<FacilityGroup>;
  checkInTimeStart: string;
  checkInTimeEnd: string;
  checkOutTime: string;
  contact: {
    phoneInfo?: Array<string>;
    faxInfo?: Array<string>;
  };
  address: Address;
  payments: Array<{ name: string; management: string }>;
  spots: Array<Access>;
  highlights: Array<Highlight>;
  covid?: Array<CovidInfoItem>;
  isCovidTextGoogleTranslated?: boolean;
  breadcrumb: Array<PlaceLayer>;
  nearbyTerminals?: Array<NearbyTerminal>;
} & AreaInfo;

export type Highlight = {
  title: string;
  postedAt: string;
  isTextsGoogleTranslated?: boolean;
  sections: Array<HighlightSection> | null;
};

export type HighlightSection = {
  title: string | null;
  description: string | null;
  media: Array<GalleryMedia> | null;
};

export type PlaceLayer = {
  name: string;
  pathId?: string;
  navigatePage?: PLACE_NAVIGATION;
};

export type Certification = {
  image?: string;
  name: string;
  type: string;
};

export type Location = {
  lat: number;
  lng: number;
  zoomLevel?: number;
};

export type NearbyTerminal = {
  name: string;
  transportation: string;
  time: number;
};

export type AreaInfo = {
  areaInfo?: {
    city?: string;
    country?: string;
    district?: string;
    region?: string;
  };
};

export type CovidInfoItem = {
  group: string;
  management: string;
  features?: Array<{
    id: string;
    title: string;
  }>;
};

export type Address = {
  addressLine: string;
  postCode: string;
  country: string;
};

type FacilityGroup = {
  group: string;
  management: string;
  features: Array<Feature>;
};

export type Feature = {
  id: string;
  text: string;
  title: string;
  description: string;
  icon: string;
  name?: string;
  selected?: boolean;
  groupId: string;
};

export type ProviderInformationErrors = {
  statusCode: number;
  message: string;
};

export type Media = {
  id: string;
  type: string;
  alt?: string;
  name?: string;
  url: string;
  videoVendorId?: string;
  thumbnailUrl?: string;
  category?: string;
  size?: MediaSize;
  description?: string;
};

export enum PROVIDER_LIST_TYPE {
  ROOM_LIST = 'roomList',
  PLAN_LIST = 'planList',
}

export type ProviderInfoListTypes = PROVIDER_LIST_TYPE.PLAN_LIST | PROVIDER_LIST_TYPE.ROOM_LIST;

export type ProviderInfoQuery = SearchFormQuery & {
  listType?: ProviderInfoListTypes;
  activeTabId?: string;
};
